<template>
  <div>
    <!-- APPROVE MODAL -->
    <div class="text-center">
      <v-dialog v-model="dialog_approve" max-width="500px" scrollable>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-card
            style="padding: 3%;"
          >
            <v-card-title>
              <v-toolbar color="white">
                <v-spacer></v-spacer>
                <v-btn
                  icon="mdi-close"
                  @click="
                    close();
                    reset();
                  "
                ></v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <v-textarea
                    type="text"
                    v-model="conditions"
                    variant="outlined"
                    label="Approve with Conditions"
                    :rules="conditions !== '' ? rules.characterRules : []"
                    rows="3"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" md="12" sm="12">
                  <v-textarea
                    type="text"
                    v-model="comments"
                    label="Comments"
                    variant="outlined"
                    :rules="rules.textRules"
                    rows="3"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" md="12" sm="12">
                  <v-text-field
                    :rules="verified ? [] : rules.passwordRules"
                    v-model="password"
                    :type="show ? 'text' : 'password'"
                    :label="verified ? 'User Verified Successfully' : 'Password (Required)'"
                    :readonly="verified"
                    variant="outlined"
                  >
                    <!-- <template v-slot:append>
                      <v-icon
                        :color="verified ? 'success' : 'error'"
                        icon="mdi-draw-pen"
                        @click="
                          dialog_verify_user = true;
                          verified = false;
                        "
                      />
                    </template> -->
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                @click="
                  close();
                  reset();
                "
                variant="flat"
                elevation="1"
              >
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :color="parentColor"
                @click="
                  updateApproval();
                "
                style="float: right"
                variant="flat"
                elevation="1"
                :loading="store.loading"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
    <!-- VERIFY USER MODAL -->
    <verify-user-modal
      :parent-color="parentColor"
    ></verify-user-modal>
  </div>
</template>

<script>
var moment = require("moment");
import axios from "axios";
import UserData from "../repository/UserData";
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";
import GlobalMethods from "../repository/GlobalMethods";
import VerifyUserModal from "./VerifyUserModal.vue";

export default {
  name: "ApproveApproval",
  
  components: {
    VerifyUserModal
  },

  props: {
    parentColor: {
      type: String,
      default: 'rgb(71, 183, 83)',
      required: false,
    },
  },

  data: () => ({
    valid: false,
    dialog: false,
    interestDisclosed: "",
    interestConflict: "",
    hasConflict: false,
    confirm: false,
    show: false,
    comments: "",
    conditions: "",
    password: "",
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
    globalMethods: GlobalMethods,
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },

    verified: {
      get: function () {
        return this.store.getVerified;
      },
      set: function (value) {
        this.store.setVerified(value);
      }
    },

    dialog_ink_signature: {
      get: function () {
        return this.store.getDialogInkSignature;
      },
      set: function (value) {
        this.store.setDialogInkSignature(value);
      }
    },

    dialog_verify_user: {
      get: function () {
        return this.store.getDialogVerifyUser;
      },
      set: function (value) {
        this.store.setDialogVerifyUser(value);
      }
    },
    
    dialog_approve: {
      get: function () {
        return this.store.getDialogApprove;
      },
      set: function (value) {
        this.store.setDialogApprove(value);
      }
    },

    current_approval: {
      get: function () {
        return this.store.getCurrentApproval;
      },
      set: function (value) {
        this.store.setCurrentApproval(value);
      }
    },

    selected_ink_signature: {
      get: function () {
        return this.store.getSelectedInkSignature;
      },
      set: function (value) {
        this.store.setSelectedInkSignature(value);
      }
    },
  },
  
  methods: {
    formatDate(date) {
      return moment.unix(date).format("DD MMM YYYY");
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    close() {
      this.store.setDialogApprove(false);
    },

    reset() {
      this.comments = "";
      this.conditions = "";
      this.password = "";
      this.interestDisclosed = "";
      this.interestConflict = "";
      this.confirm = false;
      this.hasConflict = false;
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    updateApproval() {
      this.validate().then(() => {
        if (this.valid) {
          this.store.setLoading(true);
          
          // update approval
          this.actionType = 2;

          const formData = new FormData();
          formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
          formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
          formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
          formData.append("model", "updateApproval");
          formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
          formData.append("actionType", this.actionType == 4 ? this.radio : this.actionType);
          formData.append("approvalId", UserData.getApprovalId() ? UserData.getApprovalId() : this.current_approval.approvalId);
          formData.append("comments", this.comments);
          formData.append("conditions", this.conditions);
          formData.append("categoryId", this.current_approval.categoryId);

          // if (this.verified && this.selected_ink_signature) {
          //   formData.append("signatureId", this.selected_ink_signature?.signatureId);
          // } else {
            // this.globalMethods.renewTokenLease(this.password).then((response) => {
            //   if (response.code == 200) {
                formData.append("password", this.password);
            //   } else {
            //     this.store.setLoading(false);
            //     this.alert.showError(response.response.data.message);
            //     return;
            //   }
            // })
            // .catch((e) => {
            //   this.store.setLoading(false);
            //   console.log("Error", e);
            // });
          // }

          axios.post(UserData.getBaseUrl(), formData).then((response) => {
            if (response.data?.success == 1) {
              this.$emit('approval_updated');
              this.alert.showSuccess(response.data.message);              
              document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
              this.close();
              this.reset();
            } else {
              this.alert.showError(response.data?.message ?? 'Something went wrong');
            }

            this.store.setLoading(false);
          })
          .catch((e) => {
            console.log("Error", e);
            this.store.setLoading(false);
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.list-striped a {
  text-decoration: none;
  color: #000;
}

.list-striped a:hover {
  color: rgb(72, 61, 139);
}

.list-striped a:active {
  color: rgb(72, 61, 139);
}
</style>